const embedContainer = require("./embed-container");

module.exports = function audioComponent({ value }) {
  const { embedType, nestedEmbedType, embedId, soundcloudSecretToken, caption } = value;

  if (embedType === "soundcloud") {
    return embedContainer({
      content: `
        <iframe
          style="height: 12.8rem"
          src="https://w.soundcloud.com/player/?url=https://api.soundcloud.com/tracks/${embedId}&color=ff5500${soundcloudSecretToken ? `&secret_token=${soundcloudSecretToken}&buying=false&download=false&following=false&hide_related=true&sharing=false&show_artwork=false&show_comments=false&show_playcount=false&show_reposts=false&show_teaser=false&show_user=false&visual=false` : ''}"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowfullscreen>
        </iframe>`,
      type: "audio",
      caption: caption,
    });
  } else if (embedType === "wnyc") {
    return embedContainer({
      content: `
        <iframe
          style="height: 12.8rem"
          src="https://www.wnyc.org/widgets/ondemand_player/wnyc/#file=/audio/json/${embedId}?share=0"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowfullscreen>
        </iframe>`,
      type: "audio",
      caption: caption,
    });
  } else if (embedType === "spotify") {
    let content = `
      <iframe
        style="height:12.8rem"
        src="https://open.spotify.com/embed?uri=spotify:track:${embedId}"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen>
      </iframe>`;
    if (nestedEmbedType === "spotifyplaylist") { content = generateSpotifyEmbedCode(embedId, "playlist"); }
    if (nestedEmbedType === "spotifyshow") { content = generateSpotifyEmbedCode(embedId, "show"); }
    if (nestedEmbedType === "spotifyepisode") { content = generateSpotifyEmbedCode(embedId, "episode"); }

    return embedContainer({
      content,
      type: "audio",
      caption: caption,
    });
  }

  return ""; // Return empty string for unsupported types
};

const generateSpotifyEmbedCode = (embedId, type) => {
  const baseUrl = "https://open.spotify.com/embed";
  const uri = `spotify:${type}:${embedId}`;
  return `
    <div class="embed__spotify">
      <iframe
        src="${baseUrl}?uri=${uri}"
        allow="autoplay; encrypted-media; fullscreen; vr"
        allowFullScreen="true"
        frameborder="0"
        scrolling="no">
      </iframe>
    </div>`;
};